import React from 'react';
import EmElaboracao from './EmElaboracao';

export default function GestaoOuvidorias() {
  return (
    <EmElaboracao
      title="Gestão de Ouvidorias"
      description="Registro e acompanhamento de manifestações, reclamações e elogios dos pacientes e familiares."
      icon="💬"
      section="Homecare"
    />
  );
}
